import { Controller } from 'stimulus'
import { updateCartOnPriceChange } from '~/site/pages/cart/common'
import './price_selector_component.scss'
export default class extends Controller {
  static values = {
    autoUpdate: { type: Boolean, default: true },
  }

  updateCart({ target, params }) {
    if (this.autoUpdateValue) {
      updateCartOnPriceChange({
        updatePaymentMethods: params.updatePaymentMethods,
      })
    } else {
      this.dispatch('priceChanged', {
        detail: {
          priceId: target.value,
        },
      })
    }
  }
}
